import buildRequestUrl from "./buildRequestUrl";
import removeEmptyApiParameters from "./removeEmptyApiParameters";
import { getCachedUrl, getCachedResponse } from "../cache";
import promiseChainApiCall from "./promiseChainApiCall";

const api = (parameters, breakCache = false) => {
  const sanitisedParameters = removeEmptyApiParameters(parameters);
  const url = buildRequestUrl(sanitisedParameters);

  if (url !== getCachedUrl() || breakCache === true) {
    return promiseChainApiCall(url);
  }

  return getCachedResponse();
};

export default api;
